export default {
    load: false,
    type: 'Custom',
    col: 10,
    columns: [],
    heightFixed: false,
    height: 400,
    defaultFilter: '',
    search: false,
    filters:[],
    opened:{
        searchAdd: false,
        searchEdit: false,
        list:[
            // {
            //     label: 'Поиск',
            //     type: 'label',
            //     field: '1'
            // },
            // {
            //     label: 'Загрузка выписки',
            //     type: 'switch',
            //     field: 'searchAdd'
            // },
            // {
            //     label: 'Редактирование выписки',
            //     type: 'switch',
            //     field: 'searchEdit'
            // },
        ],
    },
    data: null,


    filter: '',
    visible: false,
    rebind: true,
}